import { THEME_COLORS } from "@common/styles";
import React, { useRef, useState } from "react";
import { View, StyleSheet, Modal, Image, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ReactNativeZoomableView } from "@openspacelabs/react-native-zoomable-view";
import { Dropdown } from "@common/component";

function ZoomMedia(props) {
  let { open, setOpen, imageUri, openZoom } = props;

  const [rotation, setRotation] = useState<number>(0);
  const zoomableViewRef = useRef(null);

  const isWidthWindowLarger =
    window?.innerWidth * 0.95 > window?.innerHeight * 0.9;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dropdown show={open} onClose={handleClose}>
      <View style={styles.imageContainer}>
        <View
          style={[
            styles.buttonContainer,
            styles.flexRow,
            {
              background: `linear-gradient(to bottom, #0000001A, #000000E6)`,
            },
          ]}
        >
          <View style={styles.flexRow}>
            <TouchableOpacity
              onPress={() => zoomableViewRef.current!.zoomBy(0.5)}
            >
              <Ionicons
                name="add-circle-outline"
                size={40}
                color={THEME_COLORS.white}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => zoomableViewRef.current!.zoomBy(-0.5)}
            >
              <Ionicons
                name="remove-circle-outline"
                size={40}
                color={THEME_COLORS.white}
              />
            </TouchableOpacity>
          </View>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <TouchableOpacity
              style={{ marginEnd: 10 }}
              onPress={() => setRotation((rotation % 360) + 90)}
            >
              <MaterialCommunityIcons
                name="rotate-right"
                size={25}
                color={THEME_COLORS.white}
              />
            </TouchableOpacity>
            <TouchableOpacity style={{ marginStart: 10 }} onPress={handleClose}>
              <MaterialCommunityIcons
                name="fullscreen-exit"
                size={45}
                color={THEME_COLORS.white}
              />
            </TouchableOpacity>
          </View>
        </View>
        <ReactNativeZoomableView
          ref={zoomableViewRef}
          maxZoom={2.5}
          minZoom={1}
          initialZoom={1}
          bindToBorders={true}
        >
          <Image
            style={[
              styles.image,
              {
                transform: [{ rotate: `${rotation}deg` }],
                width: isWidthWindowLarger ? "90vh" : "95vw",
                height: isWidthWindowLarger ? "90vh" : "95vw",
              },
            ]}
            source={{ uri: imageUri }}
          />
        </ReactNativeZoomableView>
      </View>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  modalCon: {
    position: "absolute",
    height: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    borderWidth: 0,
    justifyContent: "center",
    backgroundColor: "#00000080",
  },
  imageContainer: {
    width: "95vw",
    height: "90vh",
    borderWidth: 2,
    backgroundColor: THEME_COLORS.black,
    borderColor: THEME_COLORS.grey3,
    borderRadius: 15,
    padding: 10,
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    resizeMode: "contain",
  },
  buttonContainer: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    zIndex: 10,
    paddingVertical: 40,
    justifyContent: "space-between",
    paddingLeft: 30,
    paddingRight: 50,
  },
  flexRow: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default ZoomMedia;
